import {NgModule} from "@angular/core";
import {AgChartsAngular} from "ag-charts-angular";

@NgModule({
  imports: [
    AgChartsAngular
  ],
  exports: [
    AgChartsAngular
  ],
})

export class AgModule {
}
